define('NSeComm.SkuPlpAdd', [
    'SkuPlpAdd.View',
    'jQuery'
], function NSeCommSkuPlpAdd(
    SkuPlpAdd,
    jQuery
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent('Layout');

            if (layout) {
                layout.addChildView('ProductViewsPrice.Price', function skuPlpAdd() {
                    return new SkuPlpAdd({ container: container })
                });
                
                layout.on('afterShowContent', function() {
                    jQuery( '.facets-items-collection-sku-custom' ).each(function() {
                        jQuery( this ).parents( '.facets-item-cell-grid' )
                        .find( '.product-views-price' ).prepend( this );

                        jQuery( this ).parents( '.facets-item-cell-table' )
                        .find( '.product-views-price' ).prepend( this );

                        jQuery( this ).parents( '.facets-item-cell-list' )
                        .find( '.product-views-price' ).prepend( this );
                    });
                 });
            };
        }
    }
});
